import React from "react";

const Conductor = (props) => {
    return(
    <div className="">
    <h3>Conductores Elétricos</h3>
    <span>
    Una de las prioridades de toda empresa debe ser mantener los equipos eléctricos frescos. Ya que de esto depende su vida útil, así como el funcionamiento del negocio. Si ocurre un sobrecalentamiento en gabinetes eléctricos, las consecuencias directas serán reemplazos prematuros, costos de mantenimiento y paros de producción inesperados.
    El sobrecalentamiento es un fenómeno que consiste en un aumento de temperatura en un circuito eléctrico, o en una sección de este. Además del daño potencial a los componentes del circuito, esto puede causar explosiones, incendios o lesiones. 
    <h4>Sobrecarga en conductores y componentes eléctricos</h4>
    sobrecalentamiento en gabinetes eléctricos ocurre cuando la intensidad que soportan los conductores y componentes eléctricos se ubica por encima de los valores nominales para los que fueron fabricados, por lo que en esas condiciones, la temperatura de las superficies se hace excesiva.
    Cuando la temperatura es demasiado alta se produce una sobrecarga. Este mismo efecto se puede producir por envejecimiento de la parte electrónica, por disparo de los relés térmicos, o por aumento de la temperatura de las paredes externas. 
    Los conductores deben ser normalizados y sobredimencionados al primer cálculo, ya que con el tiempo los cables pierden sus propiedades químicas y se tiende a ampliar la construcción del edificio.
    </span>
    </div>
  );
}

export {Conductor}